/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Error_DeleteInputs */



/**
* | output |
* | --- |
* | "Couldn't delete the league." |
*
* @param {League_Error_DeleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_error_delete = /** @type {((inputs?: League_Error_DeleteInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Error_DeleteInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible de supprimer la ligue.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo eliminar la liga.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não foi possível excluir a liga.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile eliminare il campionato.")
	return /** @type {LocalizedString} */ ("Couldn't delete the league.")
});